import * as React from 'react';
import {StorageSuccessModal} from "../modals/StorageSuccessModal";
import {setCookie} from "./CommonFunctions";

interface IProps {
}

interface IState {
    redirectedAfterPasswordChange: boolean;
}

export class ChangePasswordWidget extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            redirectedAfterPasswordChange: this.getPasswordRedirectSuccessfulPopUp(),
        }

        this.closeSuccessfulPasswordModal = this.closeSuccessfulPasswordModal.bind(this);
    }

    public render(): React.ReactNode {
        return (
            <div>
                <div className="panel-detail-output-entity account-details-title p-0">
                    <h2 className="inner-content dashboard-panel-title">Password</h2>
                </div>
                <div className="form-group">
                    <a id="changePasswordLink"
                        onClick={ChangePasswordWidget.setRedirectCookieForPasswordChange}
                        href={`${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/auth?client_id=${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=openid&kc_action=UPDATE_EXISTING_PASSWORD`}
                        className="buttonLink">
                        <button type="button"
                                className={"btn btn-blue-dashboard m-auto"}>
                            Change password
                        </button>
                    </a>
                </div>
                {this.state.redirectedAfterPasswordChange &&
                    <StorageSuccessModal
                        title="All done!"
                        explanationWording={<p>We’ve reset your password.</p>}
                        onClose={this.closeSuccessfulPasswordModal}
                    />
                }
            </div>
        )
    }

    private static setRedirectCookieForPasswordChange(): void {
        setCookie("redirectPage", document.URL);
    }

    private closeSuccessfulPasswordModal(): void {
        this.setState({
            redirectedAfterPasswordChange: false
        })
    }

    private getPasswordRedirectSuccessfulPopUp(): boolean {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        const action = (params.get('kc_action') ?? '').toUpperCase();
        const status = (params.get('kc_action_status') ?? '').toUpperCase();

        const pwChanged = action === 'UPDATE_EXISTING_PASSWORD' && status === 'SUCCESS';

        if (pwChanged) {
            params.delete('kc_action');
            params.delete('kc_action_status');
            params.delete('code');
            params.delete('session_state');
            params.delete('iss');
            const newUrl = url.pathname + (params.toString() ? '?' + params.toString() : '') + url.hash;
            history.replaceState(history.state, '', newUrl);
        }

        return pwChanged;
    }
}
